import {
  FC,
  PropsWithChildren,
  ReactElement,
  useCallback,
  useState,
} from 'react';

import { Capacitor } from '@capacitor/core';

import { SplashProviderContext } from '../../contexts/SplashProviderContext';

type SplashProviderProps = PropsWithChildren<{
  element: ReactElement;
}>;

export const SplashProvider: FC<SplashProviderProps> = ({
  children,
  element,
}) => {
  const [visible, setVisible] = useState(true);

  const hide = useCallback(() => {
    setVisible(() => false);
  }, []);

  const el = (() => {
    if (Capacitor.isNativePlatform()) return null;
    return element;
  })();

  return (
    <SplashProviderContext.Provider value={{ hide }}>
      {visible && el}
      {children}
    </SplashProviderContext.Provider>
  );
};
